module.exports = __webpack_public_path__ + "static/media/desktop.62f03ea4.png";